import React, { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { api } from "../../lib/api";
import Logo from "../../components/Logo";
import {
  LayoutDashboard, Image, FolderTree, ShoppingCart, Users, CreditCard, Gift,
  Share2, Ticket, Star, FileText, PanelBottom, Newspaper, GalleryHorizontal,
  Images, BarChart3, Settings, LogOut, ExternalLink, UserPlus, MessageSquare, Bell,
} from "lucide-react";

const NAV = [
  { to: "/admin", label: "Табло", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Картини", icon: Image },
  { to: "/admin/categories", label: "Категории", icon: FolderTree },
  { to: "/admin/orders", label: "Поръчки", icon: ShoppingCart },
  { to: "/admin/inquiries", label: "Запитвания", icon: MessageSquare },
  { to: "/admin/customers", label: "Клиенти", icon: Users },
  { to: "/admin/payments", label: "Плащания", icon: CreditCard },
  { to: "/admin/loyalty", label: "Лоялност", icon: Gift },
  { to: "/admin/affiliates", label: "Афилиейт", icon: Share2 },
  { to: "/admin/referrals", label: "Препоръки", icon: UserPlus },
  { to: "/admin/coupons", label: "Купони", icon: Ticket },
  { to: "/admin/reviews", label: "Отзиви", icon: Star },
  { to: "/admin/pages", label: "Страници", icon: FileText },
  { to: "/admin/footer-pages", label: "Footer страници", icon: PanelBottom },
  { to: "/admin/blog", label: "Блог", icon: Newspaper },
  { to: "/admin/sliders", label: "Слайдери", icon: GalleryHorizontal },
  { to: "/admin/media", label: "Медия", icon: Images },
  { to: "/admin/analytics", label: "Анализи", icon: BarChart3 },
  { to: "/admin/settings", label: "Настройки", icon: Settings },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const [ok, setOk] = useState(null);
  const [notif, setNotif] = useState({ new_orders: 0, new_inquiries: 0, total: 0 });

  useEffect(() => {
    if (!localStorage.getItem("pa_admin_token")) { navigate("/admin/login"); return; }
    api.get("/auth/me").then(() => setOk(true)).catch(() => { localStorage.removeItem("pa_admin_token"); navigate("/admin/login"); });
  }, [navigate]);

  useEffect(() => {
    if (!ok) return;
    const fetchNotif = () => api.get("/admin/notifications").then(({ data }) => setNotif(data)).catch(() => {});
    fetchNotif();
    const t = setInterval(fetchNotif, 30000);
    return () => clearInterval(t);
  }, [ok]);

  const logout = () => { localStorage.removeItem("pa_admin_token"); navigate("/admin/login"); };

  if (!ok) return <div className="min-h-screen bg-navy flex items-center justify-center text-ivory">Зареждане...</div>;

  return (
    <div className="min-h-screen flex bg-ivory" data-testid="admin-layout">
      <aside className="w-60 bg-navy text-ivory flex flex-col fixed h-full">
        <div className="p-4 bg-ivory shrink-0"><Logo /></div>
        <nav className="flex-1 p-3 space-y-0.5 mt-2 overflow-y-auto no-scrollbar">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 text-sm transition-colors ${isActive ? "bg-gold text-white" : "text-ivory/80 hover:bg-white/5"}`}
              data-testid={`admin-nav-${n.label}`}>
              <n.icon size={17} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-1 shrink-0">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-4 py-2.5 text-sm text-ivory/70 hover:text-gold"><ExternalLink size={16} /> Виж сайта</Link>
          <button onClick={logout} className="flex items-center gap-3 px-4 py-2.5 text-sm text-ivory/70 hover:text-gold w-full" data-testid="admin-logout"><LogOut size={16} /> Изход</button>
        </div>
      </aside>
      <main className="flex-1 ml-60">
        <div className="bg-white border-b border-stone px-8 py-3 flex items-center justify-end gap-4 sticky top-0 z-20">
          <Link to="/admin/inquiries" className="relative text-navy hover:text-gold" data-testid="notif-inquiries" title="Запитвания">
            <MessageSquare size={20} />
            {notif.new_inquiries > 0 && <span className="absolute -top-2 -right-2 bg-gold text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full">{notif.new_inquiries}</span>}
          </Link>
          <Link to="/admin/orders" className="relative text-navy hover:text-gold" data-testid="notif-bell" title="Нови поръчки">
            <Bell size={20} />
            {notif.new_orders > 0 && <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full" data-testid="notif-orders-count">{notif.new_orders}</span>}
          </Link>
        </div>
        <div className="p-8"><Outlet /></div>
      </main>
    </div>
  );
}
